import React from 'react';
import './index.css';
import imghotel from '../../../assets/no_hotel.png'
import imgplane from '../../../assets/no_plane.png'
import imgtrip from '../../../assets/no_trip.png'

export default (props: any) => {
  const { img, imgClick, type, title, customRender, style } = props;
  const imgUrl =
    img 
    ? img
    : type === 'hotel'
    ? imghotel
    : type === 'plane'
      ? imgplane
      : imgtrip
  return (
    <div className='mine-empty' >
      <img className='mine-empty-icon' src={imgUrl} style={style ? style : {}} onClick={imgClick ? imgClick : () => {}} />

      <span style={{ marginBottom: 14 }}>
        {title
          ? title
          : type === 'hotel'
          ? '暂无酒店'
          : type === 'plane'
            ? '暂无接送机'
            : '暂无行程'}
      </span>

      {customRender && customRender()}
    </div>
  )
}